<app-form-input
[parentForm]="parentForm"
[value]="delais?.receptCandidatures"
[label]="step5.getreceptcandidatures"
[type]="'datetime'" [rule]="''"
[name]="getUid()+'_SepAtt_receptCandidatures'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg9" [id]="getStepId() + rg9"></app-form-input-error> 

<app-form-input
[parentForm]="parentForm"
[value]="delais?.receptionOffres"
[label]="step5.getreceptoffres"
[type]="'datetime'" 
[rule]="'required'"
[errorMessage]="{'required' : 'ctr_1153'}"
[name]="getUid()+'_SepAtt_receptionOffres'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg6" [id]="getStepId() + rg6"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg7" [id]="getStepId() + rg7"></app-form-input-error> 
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg10" [id]="getStepId() + rg10"></app-form-input-error> 
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg11" [id]="getStepId() + rg11"></app-form-input-error>
